import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FC, useEffect } from 'react';
import { EventsBreadCrumb } from '../components/events/EventsBreadCrumb';

const NotFound: FC<any> = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <EventsBreadCrumb event={undefined} />
            <Grid container>

                <Grid size={{ md: 1, lg: 2, xl: 3 }}>

                </Grid>
                <Grid size={{ md: 10, lg: 8, xl: 6 }}>

                    <Typography align='center' variant='h1'>Sidan hittades inte</Typography>
                    <Typography align='center'>
                        <p>
                            Något gick lite fel där. Sidan du försökte nå finns inte.
                        </p>
                    </Typography>
                </Grid>
                <Grid size={{ md: 1, lg: 2, xl: 3 }}>

                </Grid>
            </Grid>
        </>
    )

}



export default NotFound;
